// src/OrderTrackingClassic.js
import React, { useState, useEffect } from "react";
import SkipNextIcon from '@material-ui/icons/SkipNext';
import { enUS, fr } from "date-fns/locale";
import { useTranslation } from 'react-i18next';
import ThriveStartUpEnrollment from 'apis/ThriveStartUpEnrollments/ThriveStartUpEnrollments';
import StartupUnEnrollmentsAPI from 'apis/startupUnEnrollments/startupUnEnrollments';
import { Styles } from "../styles";
import moment from "moment";
import {
	DatePicker,
	MuiPickersUtilsProvider,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button
} from "@material-ui/core";

export default function OrderTrackingClassic({ activeStep, setDialogObj, requestId, shipto, handleGet,setSearchValue }) {
	const [activeStep1, setActiveStep1] = useState(2);

	const [expandedSteps, setExpandedSteps] = useState({});
	const { t, i18n } = useTranslation();
	const classes = Styles();
	const [formValues, setFormValues] = useState({
		// salesRepId: '',
		billingDate: moment(new Date()).format("YYYY-MM-DD"),
		paymentDate: moment(new Date()).format("YYYY-MM-DD"),
		salesPlan: '',
		freeFreight: '',

	});
	const [data, setData] = useState([]);
	const [salesLabel, setSalesLabel] = useState("Remove");
	const [ffLabel, setFfLabel] = useState("Remove");
const [states, setStates] = useState({
		date: new Date()
	});

	const { salesRepMappingApi, billingClosureApi, addOnPlansRemover,cancelenrollmentAPI } = StartupUnEnrollmentsAPI();
	const { getstartupLogs } = ThriveStartUpEnrollment();
	const [approveLoading, setApproveLoading] = useState(false);
	const [cancelOpen, setCancelOpen] = useState(false);
		const [cancelReason, setCancelReason] = useState("");
		const [cancelLoading, setCancelLoading] = useState(false);
		const [apiLoaded, setApiLoaded] = useState(false);
	

	const locale = i18n.language == 'fr' ? fr : enUS;
	const {
		// salesRepId,
		billingDate,
		salesPlan,
		freeFreight,
		paymentDate
	} = formValues;

	useEffect(() => {
		handleGetLogs();
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormValues(prev => ({
			...prev,
			[name]: value
		}));
	};
	const getLabel = (data, keyword) => {
		const item = data.find(d =>
		  d.notes?.toLowerCase().includes(keyword.toLowerCase())
		);
	  
		// If found and it's 'apply' → 'Remove', else 'N/A'
		return item && item.value?.toLowerCase() === "apply" ? "Remove" : "Not Applicable";
	  };
	const handleGetLogs = async () => {
		try {
			let values;
			values = {
				requestId: requestId,
				type: "Unenrollment",
				shipto:shipto
			};

			const res = await getstartupLogs(values);
			if (res) {
				setData(res.data);
				const salesPlanLabel = getLabel(res?.assignData, "Sales Plan");
				const freeFreightLabel = getLabel(res?.assignData, "Free Freight");
				setSalesLabel(salesPlanLabel)
				setFfLabel(freeFreightLabel)
				setFormValues(prev => ({
				  ...prev,
				  salesPlan: salesPlanLabel,
				  freeFreight: freeFreightLabel,
				}));

				if(activeStep == 2 && !res?.data?.find(i => i.step_id == '4')) {
					setExpandedSteps(prev => ({
						...prev,
						[3]: true,
					}));
				}	
					// Assuming enrollmentDate is part of the response
					const unenrollmentDate = res.unenrollmentDate;
					
					setStates(prev => ({
						...prev,
						maxUnEnrollmentDate: unenrollmentDate,
					}));
			}
		} catch (e) {
			console.error('Get error:', e);
		} finally {
			setApiLoaded(true)
		}
	};

	const toggleStep = (index) => {
		if (index < activeStep || (activeStep == 2 && index == 3)) {
			setExpandedSteps(prev => ({
				...prev,
				[index]: !prev[index],
			}));
		}
	};

	// const handleSubmitSalesRepId = async () => {
	// 	try {
	// 		// Basic validation
	// 		if (!salesRepId || !salesRepId.trim()) {
	// 			alert("Sales Rep Email is required.");
	// 			return;
	// 		}

	// 		// Optional: email format validation
	// 		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	// 		if (!emailRegex.test(salesRepId)) {
	// 			alert("Please enter a valid email address.");
	// 			return;
	// 		}

	// 		if (!shipto || !requestId) {
	// 			alert("Missing required data (shipto or requestId).");
	// 			return;
	// 		}

	// 		const values = {
	// 			email: salesRepId,
	// 			shipto,
	// 			requestId
	// 		};

	// 		const res = await salesRepMappingApi(values);

	// 		if (res) {
	// 			setDialogObj({ open: false, obj: {}, index: null });
	// 			handleGet();
	// 		}
	// 	} catch (e) {
	// 		console.error('API Error:', e);
	// 		alert("An error occurred while submitting.");
	// 	} finally {
	// 		setDialogObj({ open: false, obj: {}, index: null });
	// 		handleGet();
	// 	}
	// };


	const handleBillingVerification = async () => {
		try {
			setApproveLoading(true)
			// Validation checks
			if (!billingDate || billingDate=='Invalid date') {
				toast.error('Please select billing date')
				return;

			}

			if (!shipto || !requestId) {
				toast.error("Missing required information (shipto or requestId).");
				return;
			}

			const values = {
				billingDate,
				shipto,
				requestId,
			};

			const res = await billingClosureApi(values);

			if (res) {
				setDialogObj({ open: false, obj: {}, index: null });
				// handleGet();
				setSearchValue('')
				setApproveLoading(false)
			}
		} catch (e) {
			console.error("API Error:", e);
			toast.error("An error occurred during billing verification.");
			setApproveLoading(false)
		} finally {
			setApproveLoading(false)
			// setDialogObj({ open: false, obj: {}, index: null });
			// handleGet();
		}
	};


	const handleAddonPlans = async () => {
		try {
			setApproveLoading(true)
			// Validate inputs
			if (!salesPlan) {
				toast.error("Please select a Sales Plan option.");
				return;
			}

			if (!freeFreight) {
				toast.error("Please select a Free Freight option.");
				return;
			}

			if (!paymentDate || paymentDate == 'Invalid date') {
				toast.error("Please select a Startup End Date.");
				return;
			}

			if (!shipto || !requestId) {
				toast.error("Missing required data: shipto or requestId.");
				return;
			}

			const values = {
				salesPlan,
				freeFreight,
				shipto,
				requestId,
				paymentDate
			};

			const res = await addOnPlansRemover(values);

			if (res) {
				setDialogObj({ open: false, obj: {}, index: null });
				// handleGet();
				setSearchValue('')
				setApproveLoading(false)

			}
		} catch (e) {
			console.error("API error:", e);
			toast.error("An error occurred while submitting Add-on Plans.");
			setApproveLoading(false)

		} finally {
		setApproveLoading(false)

			// setDialogObj({ open: false, obj: {}, index: null });
			// handleGet();
		}
	};


	const handleNext = () => setActiveStep1(prev => prev + 1);
	const handleReset = () => {
		// setActiveStep(0);
		setExpandedSteps({});
	};

	const handleCancelEnrollment = async () => {
	  if (!cancelReason.trim()) {
		toast.error("Please enter the reason.");
		return;
	  }
	 
	  if (!shipto || !requestId) {
		toast.error("Missing required data: shipto or requestId.");
		return;
	  }
	 
	  try {
		setCancelLoading(true);
	 
		const values = {
		  requestId,
		  shipto,
		  reason: cancelReason.trim()
		};
	 
		const res = await cancelenrollmentAPI(values);
	 
		if (res) {
		  toast.success("Unenrollment cancelled successfully.");
		setDialogObj({ open: false, obj: {}, index: null });
	   handleGet();
		 
	 
		  setCancelOpen(false);
		  setCancelReason("");
	 
		 
		}
	  } catch (e) {
		console.error("Cancel Unenrollment API error:", e);
		toast.error("An error occurred while cancelling enrollment.");
	  } finally {
		setCancelLoading(false);
	  }
	};

	const hasBillingClosure = data?.some(
  i => i.step_name?.toLowerCase() === "billing closure"
);
 
const hasAddOnPlans = data?.some(
  i => i.step_name?.toLowerCase() === "add-on plans remover"
);

const showCancelEnrollment =
 apiLoaded &&  !hasBillingClosure && !hasAddOnPlans;

	return (
		<div className="order-tracking">
			<style>{`
                .order-tracking {
                  max-width: 550px;
                  margin: auto;
                  font-family: "Arial", sans-serif;
                  color: #333;
                  background: #fff;
                  padding: 1.5rem;
                  border-radius: 8px;
                }
                .step {
                  display: flex;
                  position: relative;
                  margin-bottom: 2rem;
                }
                .circle-container {
                  position: relative;
                  width: 40px;
                  display: flex;
                  justify-content: center;
                }
                .circle {
                  width: 24px;
                  height: 24px;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 0.75rem;
                  font-weight: bold;
                  transition: all 0.3s ease;
                  background: #f5f5f5;
                  border: 2px solid #ccc;
                  color: #777;
                  z-index: 1;
                }
                .timeline {
                  position: absolute;
                  top: 24px;
                  bottom: -24px;
                  left: 50%;
                  transform: translateX(-50%);
                  width: 2px;
                  background: #e0e0e0;
                }
                .step:last-child .timeline {
                  display: none;
                }
                .step.active .circle {
                  background: #1976d2;
                  color: #fff;
                  border: 2px solid #1976d2;
                }
                .step.completed .circle {
                  background: #4CAF50;
                  color: #fff;
                  border: 2px solid #4CAF50;
                }
                .step-body {
                  flex: 1;
                  padding-left: 0.75rem;
                }
                .step-header {
                  cursor: pointer;
                  margin-bottom: 0.3rem;
                }
                .step-title {
                  font-weight: 600;
                  font-size: 1rem;
                }
				.step-title-incomplete {
				  font-weight: 600;
                  font-size: 1rem;
				  opacity: 0.5;
				}
                .step-date {
                  font-size: 0.85rem;
                  color: #666;
                }
                .step-content {
                  max-height: 0;
                  overflow: hidden;
                  transition: max-height 0.3s ease;
                }
                .step-content.open {
                  max-height: 1000px;
                  margin-top: 0.5rem;
				  border: 1px solid #ddd;
				  padding: 15px;
				  border-radius: 5px;
                }
                .step-content ul {
                  margin: 0.5rem 0;
                  padding-left: 1.2rem;
                }
                .step-content li {
                  margin-bottom: 0.3rem;
                  font-size: 0.9rem;
                  color: #444;
                }
                .actions {
                  margin-top: 0.6rem;
                  display: flex;
				  flex-direction: column;
                  gap: 10px;
                  float: none;
                }
                .actions button {
                  padding: 0.5rem 0.8rem;
                  border: 1px solid #1976d2;
                  border-radius: 4px;
                  background: #1976d2;
                  color: white;
                  font-size: 0.85rem;
                  cursor: pointer;
                }
                .actions button:hover {
                  background: #1565c0;
                }
                .actions button:disabled {
                  background: #f0f0f0;
                  border: 1px solid #ccc;
                  color: #999;
                  cursor: not-allowed;
                }
                .finished {
                  margin-top: 1rem;
                  padding: 1rem;
                  background: #f9f9f9;
                  border: 1px solid #ddd;
                  text-align: center;
                  border-radius: 6px;
                }
                .finished p {
                  margin: 0;
                  font-size: 0.95rem;
                  font-weight: 500;
                  color: #2e7d32;
                }
                .finished button {
                  margin-top: 0.7rem;
                  padding: 0.5rem 1rem;
                  border-radius: 4px;
                  border: 1px solid #1976d2;
                  background: #1976d2;
                  color: white;
                  cursor: pointer;
                  font-size: 0.85rem;
                }
                .finished button:hover {
                  background: #1976d2;
                }		
            `}</style>

			{/* Step 1 */}
			<Step
				index={0}
				activeStep={activeStep}
				toggleStep={toggleStep}
				expandedSteps={expandedSteps}
				title="Request Initiation"
				isCompleted={data && data.filter(i => i.step_id == '1').length > 0}
				date={moment(data.filter(i => i.step_id == '1')[data.filter(i => i.step_id == '1').length - 1]?.createdAt).format("ddd, Do MMM 'YY - h:mm A")}
				content={
					<ul>
						{data && data.filter(i => i.step_id == '1').map(d => {
							return <li>
								<div><span style={{ color: 'black' }}>{d.notes}</span><br />
									<span style={{ fontStyle: 'italic' }}>{moment(d.createdAt).format("ddd, Do MMM 'YY - h:mm A")}</span></div>
							</li>
						})}

					</ul>
				}				
			/>

			{/* Step 2 */}
			<Step
				index={1}
				activeStep={activeStep}
				toggleStep={toggleStep}
				expandedSteps={expandedSteps}
				title="Acknowledgment Notification"
				isCompleted={data && data.filter(i => i.step_id == '2').length > 0}
				date={moment(data.filter(i => i.step_id == '2')[data.filter(i => i.step_id == '2').length - 1]?.createdAt).format("ddd, Do MMM 'YY - h:mm A")}
				content={
					<ul>
						{data && data.filter(i => i.step_id == '2').map(d => {
							return <li>
								<div><span style={{ color: 'black' }}>{d.notes}</span><br />
									<span style={{ fontStyle: 'italic' }}>{moment(d.createdAt).format("ddd, Do MMM 'YY - h:mm A")}</span></div>
							</li>
						})}

					</ul>
				}				
			/>

			{showCancelEnrollment && (
                        <div
                            style={{
                            marginLeft: "262px",
                            marginTop: "-10px",
                            marginBottom: "20px"
                            }}
                        >
                            <button
                            type="button"
                            onClick={() => setCancelOpen(true)}
                            style={{
                                color: "#d32f2f",
                                background: "#fff",
                                border: "1px solid #d32f2f",
                                borderRadius: "4px",
                                padding: "8px 14px",
                                cursor: "pointer",
								width:"170px"
                            }}
                            >
                            Cancel Unenrollment
                            </button>
                        </div>
                        )}
 
 

			

			{/* Step 3 */}
			<Step
				index={2}
				activeStep={activeStep}
				toggleStep={toggleStep}
				expandedSteps={expandedSteps}
				title="Billing Closure"
				isCompleted={data && data.filter(i => i.step_id == '3').length > 0}
				date={moment(data.filter(i => i.step_id == '3')[data.filter(i => i.step_id == '3').length - 1]?.createdAt).format("ddd, Do MMM 'YY - h:mm A")}
				content={data && data.filter(i => i.step_id == '3').length > 0 ?
					<ul>
						{data.filter(i => i.step_id == '3').map(d => {
							return <li>
								<div><span style={{ color: 'black' }}>{d.notes}</span><br />
									<span style={{ fontStyle: 'italic' }}>{moment(d.createdAt).format("ddd, Do MMM 'YY - h:mm A")}</span></div>

									<li><span>Billing End Date :{moment(d.value).format("MM/DD/YYYY")}</span></li>
							</li>
						})}
					</ul> :
					<div>
						<MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
							<KeyboardDatePicker
								disableToolbar
								name="billingClosureDate"
								inputVariant="outlined"
								format={i18n.language === "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
								margin="normal"
								label="Billing Closure Date"
								id="billing-closure-date-picker"
								className={classes.dateInput}
								value={billingDate} // <-- should be a date object (moment, Date, or null)
								minDate={new Date()}
								maxDate={
									states?.maxUnEnrollmentDate
									  ? new Date(states.maxUnEnrollmentDate)
									  : null
								  }
								onChange={date => setFormValues({ ...formValues, billingDate: moment(date).format("YYYY-MM-DD") })} // <-- define this handler
								KeyboardButtonProps={{
									"aria-label": "change date",
								}}
								autoOk
								fullWidth // optional, for better layout
							/>
						</MuiPickersUtilsProvider>
					</div>
				}
				button={data && data.filter(i => i.step_id == '3').length === 0  && <button disabled={approveLoading} onClick={handleBillingVerification}>
					{approveLoading ? (
									<div className="snippet" style={{ marginLeft: 25 }}>
										<div className="stage">
											<div className="dot-typing-p"></div>
										</div>
									</div>
								) : (
									'Confirm'
								)}
							</button>}
			/>

			{/* Step 4 */}
			{/* <Step
				index={3}
				activeStep={activeStep}
				toggleStep={toggleStep}
				expandedSteps={expandedSteps}
				title="Add-on Plans"
				date={moment(data.filter(i => i.step_id == '4')[data.filter(i => i.step_id == '4').length - 1]?.createdAt).format("ddd, Do MMM 'YY - h:mm A")}
				content={data && data.filter(i => i.step_id == '4').length > 0 ?
					<ul>
						{data.filter(i => i.step_id == '4').map(d => {
							return <li>
								<div><span style={{ color: 'black' }}>{d.notes}</span><br />
									<span style={{ fontStyle: 'italic' }}>{moment(d.createdAt).format("ddd, Do MMM 'YY - h:mm A")}</span></div>
							</li>
						})}
					</ul> :
					<ul>
						<li style={{ marginBottom: '12px' }}>
							<label style={{ fontWeight: '600', display: 'block', marginBottom: '4px' }}>Sales Plan:</label>
							<label>
								<input
									type="checkbox"
									name="salesPlan"
									value="Remove"
									style={{ marginRight: 6 }}
									checked={formValues.salesPlan === "Remove"}
									onChange={handleChange}
								/>
								Remove
							</label>

						</li>

						<li style={{ marginBottom: '12px' }}>
							<label style={{ fontWeight: '600', display: 'block', marginBottom: '4px' }}>FF/Surcharge:</label>
							<label>
								<input
									type="checkbox"
									name="freeFreight"
									value="Remove"
									style={{ marginRight: 6 }}
									checked={formValues.freeFreight === "Remove"}
									onChange={handleChange}
								/>
								Remove
							</label>
						</li>
						<li>
							<div>
								<MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
									<KeyboardDatePicker
										disableToolbar
										name="Payment Plan Date"
										inputVariant="outlined"
										format={i18n.language === "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
										margin="normal"
										label="Payment Plan Date"
										id="payment-plan-date-picker"
										className={classes.dateInput}
										value={paymentDate} // <-- should be a date object (moment, Date, or null)
										minDate={new Date()}
										onChange={date => setFormValues({ ...formValues, paymentDate: moment(date).format("YYYY-MM-DD") })} // <-- define this handler
										KeyboardButtonProps={{
											"aria-label": "change date",
										}}
										autoOk
										fullWidth // optional, for better layout
									/>
								</MuiPickersUtilsProvider>
							</div>
						</li>
					</ul>
				}
				button={<button onClick={handleAddonPlans}>Finish</button>}
			/> */}

{/* <Step
  index={3}
  activeStep={activeStep}
  toggleStep={toggleStep}
  expandedSteps={expandedSteps}
  title="Add-on Plans"
  date={moment(
    data.filter(i => i.step_id == '4')[data.filter(i => i.step_id == '4').length - 1]?.createdAt
  ).format("ddd, Do MMM 'YY - h:mm A")}
  content={
    data && data.filter(i => i.step_id == '4').length > 0 ? (
      <ul>
        {data
          .filter(i => i.step_id == '4')
          .map(d => (
            <li key={d.id}>
              <div>
                <span style={{ color: 'black' }}>{d.notes}</span>
                <br />
                <span style={{ fontStyle: 'italic' }}>
                  {moment(d.createdAt).format("ddd, Do MMM 'YY - h:mm A")}
                </span>
              </div>
            </li>
          ))}
      </ul>
    ) : (
      <ul>
        <li style={{ marginBottom: '12px' }}>
          <label style={{ fontWeight: '600', display: 'block', marginBottom: '4px' }}>
            Sales Plan:
          </label>
          <label>
            <input
              type="checkbox"
              name="salesPlan"
              value="Remove"
              style={{ marginRight: 6 }}
              checked={formValues.salesPlan === "Remove"}
              onChange={handleChange}
            />
            Remove
          </label>
        </li>

        <li style={{ marginBottom: '12px' }}>
          <label style={{ fontWeight: '600', display: 'block', marginBottom: '4px' }}>
            FF/Surcharge:
          </label>
          <label>
            <input
              type="checkbox"
              name="freeFreight"
              value="Remove"
              style={{ marginRight: 6 }}
              checked={formValues.freeFreight === "Remove"}
              onChange={handleChange}
            />
            Remove
          </label>
          <div>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
              <KeyboardDatePicker
                disableToolbar
                name="Payment Plan Date"
                inputVariant="outlined"
                format={i18n.language === "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                margin="normal"
                label="Payment Plan End Date"
                id="payment-plan-date-picker"
                className={classes.dateInput}
                value={paymentDate}
                minDate={new Date()}
                onChange={date =>
                  setFormValues({
                    ...formValues,
                    paymentDate: moment(date).format("YYYY-MM-DD"),
                  })
                }
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
                fullWidth
              />
            </MuiPickersUtilsProvider>
          </div>
        </li>
      </ul>
    )
  }
  button={
    // ✅ Show button only when no data for step 4
    data && data.filter(i => i.step_id == '4').length === 0 ? (
      <button onClick={handleAddonPlans}>Finish</button>
    ) : null
  }
/> */}

<Step
  index={3}
  activeStep={activeStep}
  toggleStep={toggleStep}
  expandedSteps={expandedSteps}
  title="Add-on Plans"
  isCompleted={data && data.filter(i => i.step_id == '4').length > 0}
  date={moment(
    data.filter(i => i.step_id == '4')[data.filter(i => i.step_id == '4').length - 1]?.createdAt
  ).format("ddd, Do MMM 'YY - h:mm A")}
  content={
    data && data.filter(i => i.step_id == '4').length > 0 ? (
      <ul>
        {data
          .filter(i => i.step_id == '4')
          .map(d => (
            <li key={d.id}>
              <div>
                {/* Existing Notes */}
                <span style={{ color: 'black' }}>{d.notes}</span>
                <br />
                <span style={{ fontStyle: 'italic' }}>
                  {moment(d.createdAt).format("ddd, Do MMM 'YY - h:mm A")}
                </span>

                {/* ✅ Show Payment End Date only for "Payment Plans Remover" */}
                {d.step_name === "Payment Plans Remover" && d.value && (
                  <li style={{ marginTop: 4 }}>
                    <span style={{ color: '#333' }}>
					Startup End date: {moment(d.value).format("MM/DD/YYYY")}
                    </span>
                  </li>
                )}
              </div>
            </li>
          ))}
      </ul>
    ) : (
      // 🧩 Default form if no step_id 4 data
      <ul>
        <li style={{ marginBottom: '12px' }}>
          <label style={{ fontWeight: '600', display: 'block', marginBottom: '4px' }}>
            Sales Plan:
          </label>
          <label>
            <input
              type="checkbox"
              name="salesPlan"
              value={salesLabel}
              style={{ marginRight: 6 }}
              checked={formValues.salesPlan?.toLocaleLowerCase()  === "remove" || formValues.salesPlan?.toLocaleLowerCase()  === "not applicable"}
			  onChange={handleChange}
            />
            {salesLabel}
          </label>
        </li>

        <li style={{ marginBottom: '12px' }}>
          <label style={{ fontWeight: '600', display: 'block', marginBottom: '4px' }}>
            FF/Surcharge:
          </label>
          <label>
            <input
              type="checkbox"
              name="freeFreight"
              value={ffLabel}
              style={{ marginRight: 6 }}
              checked={formValues.freeFreight?.toLocaleLowerCase() === "remove" || formValues.freeFreight?.toLocaleLowerCase() === "not applicable"}
              onChange={handleChange}
            />
            {ffLabel}
          </label>
          <div>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
              <KeyboardDatePicker
                disableToolbar
                name="Payment Plan Date"
                inputVariant="outlined"
                format={i18n.language === "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                margin="normal"
                label="Startup End date"
                id="payment-plan-date-picker"
                className={classes.dateInput}
                value={paymentDate}
                minDate={new Date()}
				maxDate={
				states?.maxUnEnrollmentDate
				? new Date(states.maxUnEnrollmentDate)
				: null
				}
                onChange={date =>
                  setFormValues({
                    ...formValues,
                    paymentDate: moment(date).format("YYYY-MM-DD"),
                  })
                }
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
                fullWidth
              />
            </MuiPickersUtilsProvider>
          </div>
        </li>
      </ul>
    )
  }
  button={
    data && data.filter(i => i.step_id == '4').length === 0 ? (
      <button disabled={approveLoading} onClick={handleAddonPlans}>  
	  {approveLoading ? (
                <div className="snippet" style={{ marginLeft: 25 }}>
                    <div className="stage">
                        <div className="dot-typing-p"></div>
                    </div>
                </div>
            ) : (
                'Confirm'
            )}
        </button>
    ) : null
  }
/>,
<Dialog
  open={cancelOpen}
  onClose={() => {
	if (!cancelLoading) {
	  setCancelOpen(false);
	  setCancelReason("");
	}
  }}
  maxWidth="sm"
  fullWidth
  PaperProps={{
	style: {
	  width: "450px",
	  maxWidth: "90%",
	  margin: "20px",
	  overflow: "hidden"
	}
  }}
>
  <DialogTitle>
	Cancel Unenrollment
  </DialogTitle>
 
  <DialogContent
	style={{
	  overflow: "hidden",
	  paddingBottom: "10px"
	}}
  >
	<TextField
	  label="Enter the reason"
	  value={cancelReason}
	  onChange={(e) => setCancelReason(e.target.value)}
	  fullWidth
	//   multiline
	  rows={4}
	  variant="outlined"
	  margin="dense"
	/>
  </DialogContent>
 
  <DialogActions>
	<Button
	  onClick={() => {
		setCancelOpen(false);
		setCancelReason("");
	  }}
	  disabled={cancelLoading}
	>
	  Cancel
	</Button>
 
	<Button
	  variant="contained"
	  color="primary"
	 onClick={handleCancelEnrollment}
	  disabled={cancelLoading}
	>
	  {cancelLoading ? "Submitting..." : "Submit"}
	</Button>
  </DialogActions>
</Dialog>



			{/* Step 5 */}
			{/* <Step
				index={4}
				activeStep={activeStep}
				toggleStep={toggleStep}
				expandedSteps={expandedSteps}
				title="Customer Notification"
				date={moment(data.filter(i => i.step_id == '5')[data.filter(i => i.step_id == '5').length - 1]?.createdAt).format("ddd, Do MMM 'YY - h:mm A")}
				content={
					<ul>
						{data && data.filter(i => i.step_id == '5').map(d => {
							return <li>
								<div><span style={{ color: 'black' }}>{d.notes}</span><br />
									<span style={{ fontStyle: 'italic' }}>{moment(d.createdAt).format("ddd, Do MMM 'YY - h:mm A")}</span></div>
							</li>
						})}

					</ul>
				}

			/> */}
			{/* <Step
				index={5}
				activeStep={activeStep}
				toggleStep={toggleStep}
				expandedSteps={expandedSteps}
				title="Customer Notification"
				date="Wed, 2nd Jul '25"
				content={
					<ul>
						{data && data.filter(i => i.step_id == '6').map(d => {
							return <li>
								<div><span style={{ color: 'black' }}>{d.notes}</span><br />
									<span style={{ fontStyle: 'italic' }}>{moment(d.createdAt).format("ddd, Do MMM 'YY - h:mm A")}</span></div>
							</li>
						})}
						
					</ul>
				}
				 */}
			{/* /> */}



			{/* Step 7 */}


			{/* Completion Message */}
			{activeStep === 5 && (
				<div className="finished">
					<p>Completed!</p>
					<button onClick={handleReset}>Reset</button>
				</div>
			)}

		</div>
	);
}


// Helper component (still hardcoded logic)
function Step({ index, activeStep, expandedSteps, toggleStep, title, isCompleted, date, content, button }) {
	const isActive = index === activeStep;
	const isExpanded = isActive || expandedSteps[index];

	return (
		<div className={`step ${isActive ? "active" : ""} ${isCompleted ? "completed" : ""}`}>
			<div className="circle-container">
				<div className="circle">{isCompleted ? "✓" : index + 1}</div>
				<div className="timeline"></div>
			</div>
			<div className="step-body">
				<div className="step-header" onClick={() => toggleStep(index)}>
					<div className={(isCompleted || isActive || (activeStep == 2 && index == 3)) ? "step-title" : "step-title-incomplete"}>{title}</div>
					<div className="step-date">{date}</div>
				</div>
				<div className={`step-content ${isExpanded ? "open" : ""}`}>
					{content}
					<div className="actions">{button}</div>
				</div>
			</div>
		</div>
	);
}
